<template>
  <div>
    <HeroSection />
    <CurrentLocationsSection />
    <NewcomersSection />
    <RulesDownloadSection />
  </div>
</template>

<script setup lang="ts">
import HeroSection from '@/components/HeroSection.vue';
import RulesDownloadSection from '@/components/RulesDownloadSection.vue';
import NewcomersSection from '@/components/NewcomersSection.vue';
import CurrentLocationsSection from '@/components/CurrentLocationsSection.vue';

useHead({
  title: 'The Players League DFW - Pool League Home',
  meta: [
    { name: 'description', content: 'Official website for The Players League DFW. Your source for pool league standings, schedules, format information, and contact details in the Dallas-Fort Worth area.' },
    { property: 'og:title', content: 'The Players League DFW - Pool League Home' },
    { property: 'og:description', content: 'Official website for The Players League DFW. Your source for pool league standings, schedules, format information, and contact details in the Dallas-Fort Worth area.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://theplayersleaguedfw.com' },
    { property: 'og:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'The Players League DFW - Pool League Home' },
    { name: 'twitter:description', content: 'Official website for The Players League DFW. Your source for pool league standings, schedules, format information, and contact details in the Dallas-Fort Worth area.' },
    { name: 'twitter:image', content: 'https://theplayersleaguedfw.com/TPLDFW-logo.JPEG' }
  ]
});

/*
useSchemaOrg([
  defineWebSite({
    name: 'The Players League DFW',
    url: 'https://www.theplayersleague.net',
    potentialAction: [
      defineSearchAction({
        target: 'https://www.theplayersleague.net/search?q={search_term_string}',
        'query-input': 'required name=search_term_string'
      })
    ]
  }),
  defineSportsOrganization({
    name: 'The Players League DFW',
    url: 'https://www.theplayersleague.net',
    logo: 'https://www.theplayersleague.net/TPLDFW-logo.JPEG',
    sameAs: [
      'https://www.facebook.com/groups/2431630200504644',
      'https://www.facebook.com/jimdixon76033'
    ],
    sport: 'Billiards',
    location: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Fort Worth',
        addressRegion: 'TX',
        addressCountry: 'US'
      }
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+1-817-655-5758',
        contactType: 'league inquiries',
        email: 'theplayersleaguedfw@gmail.com',
        areaServed: 'US' // Assuming service is within the US
      }
    ]
  })
])
*/
</script>
